const DEVICE_ID_KEY = 'app_device_id';
const COOKIE_MAX_AGE_DAYS = 365;

const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

const setCookie = (name: string, value: string, maxAgeDays: number): void => {
  const expires = new Date();
  expires.setDate(expires.getDate() + maxAgeDays);
  const cookieValue = encodeURIComponent(value);
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${cookieValue}; Path=/; SameSite=Lax; Max-Age=${maxAgeDays * 24 * 60 * 60}; Expires=${expires.toUTCString()}${secure}`;
};

const removeCookie = (name: string): void => {
  document.cookie = `${name}=; Path=/; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT`;
};

const storeDeviceId = (deviceId: string): void => {
  localStorage.setItem(DEVICE_ID_KEY, deviceId);
  setCookie(DEVICE_ID_KEY, deviceId, COOKIE_MAX_AGE_DAYS);
};

export const getDeviceId = (): string => {
  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = getCookie(DEVICE_ID_KEY);
    if (deviceId) {
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
  }

  if (!deviceId) {
    // Generate a new device ID if none exists (e.g. on first login)
    deviceId = generateDeviceId();
    storeDeviceId(deviceId);
  } else {
    // Ensure cookie is in sync (e.g. if restored from localStorage)
    const cookieValue = getCookie(DEVICE_ID_KEY);
    if (cookieValue !== deviceId) {
      setCookie(DEVICE_ID_KEY, deviceId, COOKIE_MAX_AGE_DAYS);
    }
  }

  return deviceId;
};

const generateDeviceId = (): string => {
  // Generate a unique device ID using timestamp and random values (mohamed-said style)
  const timestamp = new Date().getTime();
  const random = Math.random().toString(36).substring(2, 15);
  return `${timestamp}-${random}`;
};

/**
 * Clear device ID from localStorage and cookies (useful for testing or troubleshooting).
 * A new ID will be generated on next API request (e.g. next login).
 */
export const clearDeviceId = (): void => {
  localStorage.removeItem(DEVICE_ID_KEY);
  removeCookie(DEVICE_ID_KEY);
};
